// Format MTTR: show hours for < 24h, days for >= 24h with full text (e.g., "67 days", "12 hrs")
export const formatMttr = (hours) => {
  if (hours == null) return { value: 'Unavailable', suffix: '' };
  if (hours < 24) return { value: hours, suffix: ' hrs' };
  return { value: Math.round(hours / 24), suffix: ' days' };
};

// Single-string form for table cells, e.g. "12 hrs", "3 days", "Unavailable".
export const formatMttrText = (hours) => {
  const { value, suffix } = formatMttr(hours);
  return `${value}${suffix}`;
};
